export default __webpack_public_path__ + "static/media/tutorial-tour.a1b82a76.png";